<template>
    <div>
        <div class="content-wrap">
            <div class="menu">
                <div class="container">
                    <Menubar></Menubar>
                </div>
            </div>
            <div class="container content">
                <div>
                    <ul class="curriculum-menu">
                        <li v-for="(menu, index) in menuList" :key='index'>
                            <router-link
                                :to="menu.url"
                                :class="[checkUrl(menu.realPath)]"
                                v-html='menu.menuTitle'
                            ></router-link>
                            <!-- <router-link  :to="getLinkObject(menu)" :class="" ><span>{{menu.menuTitle}}</span></router-link> -->
                            <ul class="curriculum-submenu" v-if="menu.submenu">
                                <li v-for="(subMenu, index) in menu.submenu" :key='index'>
                                    <router-link :to="subMenu.url">
                                        <a v-smooth-scroll :href="subMenu.url">{{subMenu.menuTitle}}</a>
                                    </router-link>
                                    <!-- <a v-smooth-scroll :href="subMenu.url">{{subMenu.menuTitle}}</a> -->
                                </li>
                            </ul>
                        </li>
                    </ul>
                </div>
                <div>
                    <component :is="loadComponent" :menuType="menuType"></component>
                    <div v-if="submenuType" class="sub-component">
                        <component :is="loadSubComponent" :menuType="menuType+'_'+submenuType"></component>
                    </div>
                </div>
            </div>
        </div>
        <div class="container">
            <Footer></Footer>
        </div>
    </div>
</template>
<script>
import Menubar from "../../components/menubar/LaptopLayout.vue";
import Footer from "@/components/footer/FooterLaptop.vue";
import MenuList from "../../text/curriculum/menu.js";
export default {
    name: "CurriculumLaptopFrame",
    components: { Menubar, Footer },
    props: ["menuType", "submenuType"],
    data() {
        return {
            menuList: MenuList.menuList[this.$store.state.lang]
        };
    },

    methods: {
        checkUrl(url) {
            if (this.$route.path.indexOf(url) != -1) {
                return "router-link-exact-active";
            }
            return "";
        }
    },
    computed: {
        loadComponent() {
            let componentType = MenuList.contentType[this.menuType]
                ? MenuList.contentType[this.menuType]
                : this.menuType;
            componentType = componentType.charAt(0).toUpperCase() + componentType.slice(1);
            return () => import("./" + componentType + "Laptop.vue");
        },
        loadSubComponent() {
            let componentType = MenuList.contentType[
                this.menuType + "_" + this.submenuType
            ]
                ? MenuList.contentType[this.menuType + "_" + this.submenuType]
                : this.submenuType;
            componentType = componentType.charAt(0).toUpperCase() + componentType.slice(1);
            return () => import("./" + componentType + "Laptop.vue");
        }
    }
};
</script>

<style  scoped>
.content-wrap {
    width: 100%;
    overflow: hidden;
    padding-bottom: 120px;
    background-color: #fffcf7;
}
.menu {
    height: 100px;
    background-color: #42c0ff;
}
.container {
    margin: 0 auto;
    height: auto;
    min-height: 100px;
    width: 1024px;
}
.content {
    padding-top: 94px;
    display: flex;

    align-items: stretch;
}
.content > div:first-child {
    width: 258px;
    padding-left: 11px;
}
.content > div:last-child {
    width: 766px;
    margin-top: -11px;
}
.curriculum-menu {
    list-style-type: none;
    font-size: 18px;
    font-weight: normal;
    font-style: normal;
    font-stretch: normal;
    line-height: normal;
    letter-spacing: -0.4px;
    color: #41403e;
    padding: 0;
    margin: 0;
    text-align: left;
}
.curriculum-submenu {
    list-style-type: none;
    font-size: 18px;
    font-weight: normal;
    font-style: normal;
    font-stretch: normal;
    line-height: normal;
    letter-spacing: -0.4px;
    color: #41403e;
    padding: 0;
    margin: 0;
    text-align: left;
    margin-top: 32px;
    position: relative;
    left: 21px;
}

.curriculum-menu li ~ li,
.curriculum-submenu li ~ li {
    margin-top: 29px;
}
.curriculum-menu li a.router-link-active {
    font-size: 18px;
    font-weight: bold;
    font-style: normal;
    font-stretch: normal;
    line-height: normal;
    letter-spacing: -0.4px;
    color: #42c0ff;
}
.curriculum-menu li a ~ ul.curriculum-submenu {
    display: none;
}
.curriculum-menu li a.router-link-active ~ ul,
.curriculum-menu li a.router-link-exact-active ~ ul {
    display: block;
}
.curriculum-menu li a.router-link-exact-active,
.curriculum-submenu li a.router-link-active {
    font-size: 18px;
    font-weight: bold;
    font-style: normal;
    font-stretch: normal;
    line-height: normal;
    letter-spacing: -0.4px;
    color: #42c0ff;
}
.sub-component::before {
    content: "";
    width: 100%;
    height: 1px;
    background-color: #e6e6e6;
    margin-left: 41px;
    margin-right: 11px;
    position: relative;
    display: block;
    top: 0;
    margin-bottom: 60px;
}
</style>



// WEBPACK FOOTER //
// src/pages/curriculum/CurriculumLaptop.vue